import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../common/app.constants';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class CustomImgService {

  constructor(private http: HttpClient) { }

  getAllCustomImg(): Observable<any> {
    return this.http.get(AppConstants.API_URL + 'customImg/listOriByUser', httpOptions);
  }

  getCustomImgId(id): Observable<any> {
    return this.http.get(AppConstants.API_URL + 'customImg/' + id, httpOptions);
  }

  addCustomImg(data): Observable<any> {
    return this.http.post(AppConstants.API_URL + 'customImg/add', data, httpOptions);
  }

  deleteCustomImgById(id): Observable<any> {
    return this.http.delete(AppConstants.API_URL + `customImg/${id}`, httpOptions);
  }

  updateCustomImg(data): Observable<any> {
    return this.http.put(AppConstants.API_URL + 'customImg/update', data, httpOptions);
  }

  findBySlug(slug): Observable<any> {
    return this.http.get(AppConstants.API_URL + `customImg/findBySlug?slug=` + slug, httpOptions);
  }
}